// extracted by mini-css-extract-plugin
export default {"container":"Zp-z","brandName":"_p-z","productName":"aq-z","breakLongProductName":"bq-z"};